import { Component, OnInit } from "@angular/core";
import { ZPNotification } from "src/app/models/zpnotification";
import { AdminDashboardService } from "src/app/services/admin-dashboard.service";
import { NotificationService } from "src/app/services/notification.service";
import { SideNavBarVisibilityService } from "src/app/services/side-nav-bar-visibility.service";
import { ZpDataService } from "src/app/services/zp-data.service";
import { ThemeService } from "src/app/theme/theme-service.service";

@Component({
    selector: "app-advisor-hub",
    templateUrl: "./advisor-hub.component.html",
    styleUrls: ["./advisor-hub.component.scss"],
    standalone: false
})
export class AdvisorHubComponent implements OnInit {
  public professionals: any = [];
  public selectedId;
  public clientAccessPageUrl: string;
  public myUser: any;

  currentPage: number = 1;
  totalPages: number;
  pageSize: number = 20; // Set your desired page size here
  filter: string = '{"userType":"professional"}';
  public dataIsLoaded: boolean;
  public usersFoundArray: any;
  public usersFound: boolean;
  public message: string;
  public isSearching: boolean;
  public searchData;

  constructor(
    private api: ZpDataService,
    private adminApi: AdminDashboardService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    public themeService: ThemeService,
    private notifications: NotificationService
  ) {}

  async ngOnInit() {
    this.loadPage(this.currentPage);
    this.sideNavBarVisibilityService.changeMessage("top");
  }

  loadPage(page: number) {
    this.api.getAllUsers(page, undefined, this.pageSize, this.filter).then(result => {
      this.professionals = result.users;
      this.currentPage = result.page;
      this.totalPages = result.pages;
    });
  }

  toggleSection(professionalId, clientAccessPage?) {
    console.log(professionalId);

    this.clientAccessPageUrl = clientAccessPage || "";

    if (this.selectedId === professionalId) {
      this.selectedId = null;
    } else {
      this.selectedId = professionalId;
    }
  }

  async saveItem(user, clientAccessPageUrl) {
    console.log(user);
    this.myUser = user;
    let result;

    if (clientAccessPageUrl === "") {
      result = await this.adminApi.updateClienteAccessPage(this.selectedId);
    } else {
      result = await this.adminApi.updateClienteAccessPage(
        this.selectedId,
        clientAccessPageUrl
      );
    }
    if (result && result.success) {
      this.notifications.changeMessage(new ZPNotification("Item Saved"));
      this.toggleSection(this.selectedId);
      this.loadPage(this.currentPage);
    } else {
      this.notifications.changeMessage(new ZPNotification("Save failed"));
    }
  }

  async searchByLastName(searchData) {
    this.dataIsLoaded = false;
    this.isSearching = true;
    let jsonData = `{"userType":"professional","lastName":"${searchData}"}`;
    let data = await this.api.getAllUsers(
      undefined,
      undefined,
      undefined,
      jsonData
    );
    console.log("data - ", data);
    this.dataIsLoaded = true;
    if (data.users.length > 0) {
      this.usersFoundArray = data.users;
      this.usersFound = true;
    } else {
      this.usersFound = false;
      this.message = "This user does not exist.";
    }
  }

  backToTable() {
    this.isSearching = false;
  }
}
